import moment from 'moment'


export const addDaysToDate = (date, days=1) => (
  moment(date).add(days, 'days').format("YYYY-MM-DD")
)
